import FormControlLabel, {
  type FormControlLabelProps,
} from '@mui/material/FormControlLabel';
import Switch, { type SwitchProps } from '@mui/material/Switch';
import {
  type FieldValues,
  type Path,
  type PathValue,
  type UseControllerProps,
  useController,
} from 'react-hook-form';

type RHFSwitchProps<TField extends FieldValues> = {
  label?: FormControlLabelProps['label'];
  switchProps?: SwitchProps;
  controlLabelProps?: Omit<FormControlLabelProps, 'label' | 'control'>;
  controlProps: UseControllerProps<TField>;
};

export const RHFSwitch = <TField extends FieldValues>({
  label,
  controlLabelProps,
  switchProps,
  controlProps,
}: RHFSwitchProps<TField>) => {
  const { field } = useController({
    ...controlProps,
    defaultValue: !!controlProps.defaultValue as PathValue<
      TField,
      Path<TField>
    >,
  });

  return (
    <FormControlLabel
      {...controlLabelProps}
      label={label}
      control={
        <Switch
          {...switchProps}
          {...field}
          checked={!!field.value}
          onChange={(...args) => {
            field.onChange(...args);
            switchProps?.onChange?.(...args);
          }}
        />
      }
    />
  );
};
